/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as publicRouteRouteImport } from './routes/(public)/route'
import { Route as authIndexRouteImport } from './routes/(auth)/index'
import { Route as publicImpersonarRouteImport } from './routes/(public)/impersonar'
import { Route as publicLoginRouteImport } from './routes/(public)/login'
import { Route as publicRegistroRouteImport } from './routes/(public)/registro'
import { Route as publicWavesurferRouteImport } from './routes/(public)/wavesurfer'
import { Route as authEntregasIndexRouteImport } from './routes/(auth)/entregas/index'
import { Route as authEntregasDetalleRouteImport } from './routes/(auth)/entregas/detalle'
import { Route as authExpedienteIndexRouteImport } from './routes/(auth)/expediente/index'
import { Route as authPerfilIndexRouteImport } from './routes/(auth)/perfil/index'

const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const publicRouteRoute = publicRouteRouteImport.update({
  id: '/(public)',
  getParentRoute: () => rootRouteImport,
} as any)
const authIndexRoute = authIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authRouteRoute,
} as any)
const publicImpersonarRoute = publicImpersonarRouteImport.update({
  id: '/impersonar',
  path: '/impersonar',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicRegistroRoute = publicRegistroRouteImport.update({
  id: '/registro',
  path: '/registro',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicWavesurferRoute = publicWavesurferRouteImport.update({
  id: '/wavesurfer',
  path: '/wavesurfer',
  getParentRoute: () => publicRouteRoute,
} as any)
const authEntregasIndexRoute = authEntregasIndexRouteImport.update({
  id: '/entregas/',
  path: '/entregas/',
  getParentRoute: () => authRouteRoute,
} as any)
const authEntregasDetalleRoute = authEntregasDetalleRouteImport.update({
  id: '/entregas/detalle',
  path: '/entregas/detalle',
  getParentRoute: () => authRouteRoute,
} as any)
const authExpedienteIndexRoute = authExpedienteIndexRouteImport.update({
  id: '/expediente/',
  path: '/expediente/',
  getParentRoute: () => authRouteRoute,
} as any)
const authPerfilIndexRoute = authPerfilIndexRouteImport.update({
  id: '/perfil/',
  path: '/perfil/',
  getParentRoute: () => authRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/impersonar': typeof publicImpersonarRoute
  '/login': typeof publicLoginRoute
  '/registro': typeof publicRegistroRoute
  '/wavesurfer': typeof publicWavesurferRoute
  '/': typeof authIndexRoute
  '/entregas/detalle': typeof authEntregasDetalleRoute
  '/entregas/': typeof authEntregasIndexRoute
  '/expediente/': typeof authExpedienteIndexRoute
  '/perfil/': typeof authPerfilIndexRoute
}
export interface FileRoutesByTo {
  '/impersonar': typeof publicImpersonarRoute
  '/login': typeof publicLoginRoute
  '/registro': typeof publicRegistroRoute
  '/wavesurfer': typeof publicWavesurferRoute
  '/': typeof authIndexRoute
  '/entregas/detalle': typeof authEntregasDetalleRoute
  '/entregas': typeof authEntregasIndexRoute
  '/expediente': typeof authExpedienteIndexRoute
  '/perfil': typeof authPerfilIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/(public)': typeof publicRouteRouteWithChildren
  '/(public)/impersonar': typeof publicImpersonarRoute
  '/(public)/login': typeof publicLoginRoute
  '/(public)/registro': typeof publicRegistroRoute
  '/(public)/wavesurfer': typeof publicWavesurferRoute
  '/(auth)/': typeof authIndexRoute
  '/(auth)/entregas/detalle': typeof authEntregasDetalleRoute
  '/(auth)/entregas/': typeof authEntregasIndexRoute
  '/(auth)/expediente/': typeof authExpedienteIndexRoute
  '/(auth)/perfil/': typeof authPerfilIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/impersonar'
    | '/login'
    | '/registro'
    | '/wavesurfer'
    | '/'
    | '/entregas/detalle'
    | '/entregas/'
    | '/expediente/'
    | '/perfil/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/impersonar'
    | '/login'
    | '/registro'
    | '/wavesurfer'
    | '/'
    | '/entregas/detalle'
    | '/entregas'
    | '/expediente'
    | '/perfil'
  id:
    | '__root__'
    | '/(auth)'
    | '/(public)'
    | '/(public)/impersonar'
    | '/(public)/login'
    | '/(public)/registro'
    | '/(public)/wavesurfer'
    | '/(auth)/'
    | '/(auth)/entregas/detalle'
    | '/(auth)/entregas/'
    | '/(auth)/expediente/'
    | '/(auth)/perfil/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  publicRouteRoute: typeof publicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)': {
      id: '/(public)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof publicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/': {
      id: '/(auth)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(public)/impersonar': {
      id: '/(public)/impersonar'
      path: '/impersonar'
      fullPath: '/impersonar'
      preLoaderRoute: typeof publicImpersonarRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/login': {
      id: '/(public)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof publicLoginRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/registro': {
      id: '/(public)/registro'
      path: '/registro'
      fullPath: '/registro'
      preLoaderRoute: typeof publicRegistroRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/wavesurfer': {
      id: '/(public)/wavesurfer'
      path: '/wavesurfer'
      fullPath: '/wavesurfer'
      preLoaderRoute: typeof publicWavesurferRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(auth)/entregas/': {
      id: '/(auth)/entregas/'
      path: '/entregas'
      fullPath: '/entregas/'
      preLoaderRoute: typeof authEntregasIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/entregas/detalle': {
      id: '/(auth)/entregas/detalle'
      path: '/entregas/detalle'
      fullPath: '/entregas/detalle'
      preLoaderRoute: typeof authEntregasDetalleRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/expediente/': {
      id: '/(auth)/expediente/'
      path: '/expediente'
      fullPath: '/expediente/'
      preLoaderRoute: typeof authExpedienteIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/perfil/': {
      id: '/(auth)/perfil/'
      path: '/perfil'
      fullPath: '/perfil/'
      preLoaderRoute: typeof authPerfilIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authIndexRoute: typeof authIndexRoute
  authEntregasDetalleRoute: typeof authEntregasDetalleRoute
  authEntregasIndexRoute: typeof authEntregasIndexRoute
  authExpedienteIndexRoute: typeof authExpedienteIndexRoute
  authPerfilIndexRoute: typeof authPerfilIndexRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authIndexRoute: authIndexRoute,
  authEntregasDetalleRoute: authEntregasDetalleRoute,
  authEntregasIndexRoute: authEntregasIndexRoute,
  authExpedienteIndexRoute: authExpedienteIndexRoute,
  authPerfilIndexRoute: authPerfilIndexRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface publicRouteRouteChildren {
  publicImpersonarRoute: typeof publicImpersonarRoute
  publicLoginRoute: typeof publicLoginRoute
  publicRegistroRoute: typeof publicRegistroRoute
  publicWavesurferRoute: typeof publicWavesurferRoute
}

const publicRouteRouteChildren: publicRouteRouteChildren = {
  publicImpersonarRoute: publicImpersonarRoute,
  publicLoginRoute: publicLoginRoute,
  publicRegistroRoute: publicRegistroRoute,
  publicWavesurferRoute: publicWavesurferRoute,
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(
  publicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  publicRouteRoute: publicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
